/// <amd-module name="VSSUI/TextField" />
export { TextField } from "./Components/TextField/TextField";
export { TextFieldWithMessage } from "./Components/TextField/TextFieldWithMessage";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export {
    ITextField,
    ITextFieldProps,
    ITextFieldWithMessageProps,
    TextFieldFocusTreatmentBehavior,
    TextFieldStyle,
    TextFieldWidth
} from "./Components/TextField/TextField.Props";
